import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { CampaignsPage } from '@/features/messaging/components/campaigns-view';

const searchSchema = z.object({
  // ?id=<uuid> selecciona la campaña abierta en el panel derecho.
  id: z.string().uuid().optional(),
});

export const Route = createFileRoute('/_app/correo/campaigns/')({
  validateSearch: searchSchema,
  component: CampaignsPage,
});
